<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container" v-if="Data">
            <div class="col-md-12 pt-4">
              <h4 class="page-header">
                Points
              </h4>
              <hr />
              <div class="row">
                <div class="col-md-6">
                  <p><strong>Name: </strong>{{ ClientName }}</p>
                  <p><strong>Username: </strong> {{ Username }}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>Points: </strong> {{ Points }}</p>
                </div>
              </div>
              <hr />
              <form class="border p-3 mb-3 rounded" name="addpoints" id="addpoints" @submit.prevent="updatePoints">
                <fieldset>
                  <legend>Add/Subtract user points</legend>
                  <p>* These fields are required.</p>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="type">Type*: </label>
                        <b-form-select v-model="Type">
                          <option value="points added">Add Points</option>
                          <option value="points subtracted">Subtract Points</option>
                        </b-form-select>
                      </div>
                      <div class="form-group">
                        <label for="points">Points*: </label>
                        <input v-model="ChangePointsBy" type="text" name="points" size="8" class="form-control" />
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="comments">Why are these points being added?:</label>
                    <textarea v-model="Comment" cols="60" rows="5" name="comments" class="form-control"></textarea>
                  </div>
                  <div class="form-group">
                    <button class="btn btn-primary" type="submit">
                      Add points
                    </button>
                  </div>
                </fieldset>
              </form>

              <form class="border p-3 rounded mb-3" name="credit" id="credit" @submit.prevent="creditPoints">
                <fieldset>
                  <legend>Credit points</legend>
                  <p>* These fields are required.</p>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="transaction">Please select one of the following*: </label>
                        <b-form-select v-model="Transaction">
                          <option value="0">Credit not for an order</option>
                          <option v-for="transaction in TransactionDropDownResult" :key="transaction.id" :value="transaction.id">
                            Order: {{ transaction.orderNumber }} ; Points:
                            {{ transaction.points }}
                          </option>
                        </b-form-select>
                      </div>
                      <div class="form-group">
                        <label for="points">Points to credit*: </label><br />(Only if "credit not for an order" is selected above)
                        <input v-model="CreditedPoints" type="text" size="8" id="points" class="form-control" />
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="comments">Explanation:</label>
                    <textarea v-model="Explanation" cols="60" rows="5" class="form-control"></textarea>
                  </div>
                  <div class="form-group">
                    <button type="Submit" class="btn btn-primary" >Credit Points</button>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import DivvyAdminSidebar from '@/views/divvyadmin/divvyAdminSidebar.vue';

export default {
  name: 'UsersUserPoint',
  props: ['id'],
  data() {
    return {
      Data: null,
      ClientName: '',
      Username: '',
      Points: 0,
      Type: 'points added',
      ChangePointsBy: 0,
      Comment: '',
      Transaction: 0,
      CreditedPoints: 0,
      Explanation: '',
      fName: '',
      lName: '',
    };
  },
  components: {
    DivvyAdminSidebar,
    Header,
    Footer,
  },

  computed: {
    TransactionDropDownResult() {
      return this.$store.getters['manageUsers/getTransactionDropDownResult'];
    },
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch('divvyAdminSidebar/setActive', {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : 'usersmodule',
        activeMenu: this.activeMenu ? this.activeMenu : 'clientusermanagement',
      });
    },
    setData(data) {
      this.Data = data;
      this.Username = data.username;
      this.fName = data.firstName ? data.firstName : '';
      this.lName = data.lastName ? data.lastName : '';
      this.ClientName = this.fName + ',' + this.lName;
      this.Points = data.pointsAvailable;
    },
    updatePoints() {
      if (this.Comment.trim() === '') {
        alert('You must supply a reason for this points addition/subtraction.');
        return;
      }
      this.$store
        .dispatch('manageUsers/setChangedPoints', {
          user_id: +this.id,
          type: this.Type,
          points: +this.ChangePointsBy,
          comment: this.Comment,
        })
        .then(() => {
          this.$store.dispatch('manageUsers/fetchGetUsers');
        })
        .then(() => {
          this.$router.push({
            name: 'DivvyAdminUsersPointsScreen',
            params: {
              Name: this.fName + ' ' + this.lName,
              Type: this.Type === 'points added' ? 'Points Added' : 'Points Subtracted',
            },
          });
        });
    },
    creditPoints() {
      if (this.Explanation.trim() === '') {
        alert('You must supply a reason for this credit.');
        return;
      }
      this.$store
        .dispatch('manageUsers/setCreditedPoints', {
          user_id: +this.id,
          // type: this.Transaction,
          type: 'credit',
          points: +this.CreditedPoints,
          comment: this.Explanation,
        })
        .then(() => {
          this.$store.dispatch('manageUsers/fetchGetUsers');
        })
        .then(() => {
          this.$router.push({
            name: 'DivvyAdminUsersPointsScreen',
            params: { Name: this.ClientName },
          });
        });
    },
  },

  created() {
    this.setActiveMenuItem();
    this.$store
      .dispatch('manageUsers/fetchExistingDetails', {
        userId: this.id,
      })
      .then((data) => this.setData(data));

    this.$store.dispatch('manageUsers/setTransactionDropDownResult', {
      userId: this.id,
      transactionType: 'order',
    });
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
